import { http } from './config'

export default {

  getAllLoadSteps: () => {
    return http.get('load_steps')
  },

  getLoadStepById: (load_step_id) => {
    return http.get('load_steps/' + load_step_id)
  },

  create: (load_step) => {
    return http.post('load_steps', {
      "load_step": {
        "step_sequence": load_step.step_sequence,
        "status_id": load_step.status.id,
        "role_id": load_step.role.id
      }
    })
  },

  update: (id, load_step) => {
    return http.put(`load_steps/${id}`, {
      "load_step": {
        "step_sequence": load_step.step_sequence,
        "status_id": load_step.status.id,
        "role_id": load_step.role.id
      }
    })
  },

  remove: (id) => {
    return http.delete(`load_steps/${id}`)
  }

}
